// extracted by mini-css-extract-plugin
export default {"load":"loading_load__Ls3fA","spin":"loading_spin__QORUA"};